import { render, staticRenderFns } from "./work_item_type_icon.vue.js?vue&type=template&id=1a1de8b4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_type_icon.vue?vue&type=template&id=1a1de8b4"
import script from "./work_item_type_icon.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_type_icon.vue?vue&type=script&lang=js"
export * from "./work_item_type_icon.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_type_icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a1de8b4')) {
      api.createRecord('1a1de8b4', component.options)
    } else {
      api.reload('1a1de8b4', component.options)
    }
    module.hot.accept("./work_item_type_icon.vue.js?vue&type=template&id=1a1de8b4!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./work_item_type_icon.vue?vue&type=template&id=1a1de8b4", function () {
      api.rerender('1a1de8b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "work_items/components/work_item_type_icon.vue"
export default component.exports